import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useState } from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import Close from '@wix/da-ds/pkg/Icons/16x16/Close';
import cn from 'classnames';
import adunitStyles from './adunits.scss';
const MobileAdhesion = /*#__PURE__*/ React.memo(({ safety = 'off', safetyState })=>{
    const [hidden, setHidden] = useState(false);
    const _useAdUnit = useAdUnit(AdProviders.Gak, ADUNIT_MAP['UserMobileAdhesionGam'], safety, safetyState, {
        refreshLimit: 30,
        refreshTimeout: 240000,
        size: [
            [
                320,
                50
            ],
            [
                300,
                50
            ],
            [
                300,
                75
            ],
            [
                300,
                100
            ]
        ],
        /* prettier-ignore */ /* Allows taller unit on big screen like modern iphones and ipads */ responsiveSizeMap: [
            [
                [
                    1,
                    800
                ],
                [
                    [
                        320,
                        50
                    ],
                    [
                        300,
                        50
                    ],
                    [
                        300,
                        75
                    ],
                    [
                        300,
                        100
                    ]
                ]
            ],
            [
                [
                    1,
                    700
                ],
                [
                    [
                        320,
                        50
                    ],
                    [
                        300,
                        50
                    ],
                    [
                        300,
                        75
                    ]
                ]
            ],
            [
                [
                    1,
                    300
                ],
                [
                    [
                        320,
                        50
                    ],
                    [
                        300,
                        50
                    ]
                ]
            ],
            [
                [
                    0,
                    0
                ],
                []
            ]
        ],
        targeting: {
            unitType: 'atf'
        }
    }), { advertIsOff } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff === 'off') {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(adunitStyles['adhesion'], adunitStyles['mobile'], hidden && adunitStyles['hidden'])
    }, !hidden && /*#__PURE__*/ React.createElement("div", slotAttr), /*#__PURE__*/ React.createElement(IconButton, {
        "aria-label": "Hide Advertisment",
        icon: Close,
        size: 'small',
        onClick: ()=>{
            setHidden(true);
        }
    }));
}, adunitMemo);
MobileAdhesion.displayName = 'MobileAdhesion';
export default MobileAdhesion;
